import { GetServerSidePropsContext } from 'next';

export const getDisplayLanguageFromCookieOnServerSide = (
  context: GetServerSidePropsContext,
  val: string
) => {
  const { req } = context;
  const cookieString = req?.headers?.cookie;
  if (!cookieString) {
    return ''; // Handle case where there is no cookie string
  }
  // Split the cookie string into individual cookies
  const cookies = cookieString?.split(';');
  // Find the cookie that starts with the specified value (e.g., "display-language=")
  const foundCookie = cookies?.find((cookie) =>
    cookie?.trim()?.startsWith(val)
  );
  if (!foundCookie) {
    return ''; // Handle case where the specified cookie is not found
  }
  const parts = foundCookie.split('=');
  if (parts?.length < 2) {
    return ''; // Handle case where the cookie value is missing
  }
  return parts[1]?.trim();
};

export const getCookieDataOnServerSide = (
  cookieString: string,
  value: string
) => {
  if (!cookieString || !value) return '';

  const cookiesArray = cookieString && cookieString.split(';');

  const result =
    cookiesArray &&
    cookiesArray?.find((string) => string?.trim()?.startsWith(value));

  if (!result) return '';

  const finalValue = result?.split('=');

  return finalValue.length > 1 ? finalValue[1] : '';
};
